export const ALLOWED_USER_GEOMETRY_EXTENSIONS = ['kml', 'kmz'] as const

export type UserGeometryExtension = (typeof ALLOWED_USER_GEOMETRY_EXTENSIONS)[number]

// Single 50 MB ceiling shared by every size guard: whole file, compressed KMZ,
// total unzipped payload and any single KML entry inside a KMZ.
export const USER_GEOMETRY_MAX_FILE_BYTES = 50 * 1024 * 1024

export const MAX_USER_GEOMETRIES = 50
export const MAX_ACTIVE_USER_GEOMETRIES = 100
export const MAX_KML_ENTRIES_PER_KMZ = 9999

// Per-feature layer styling is only offered when the file has at most this many features.
export const USER_GEOMETRY_LAYER_EDIT_MAX_FEATURES = 30

export const USER_GEOMETRY_NAME_MAX_LENGTH = 100

export const userGeometryLimits = {
  maxFileBytes: USER_GEOMETRY_MAX_FILE_BYTES,
  maxGeometries: MAX_USER_GEOMETRIES,
  maxActiveGeometries: MAX_ACTIVE_USER_GEOMETRIES,
  maxKmlEntriesPerKmz: MAX_KML_ENTRIES_PER_KMZ,
  layerEditMaxFeatures: USER_GEOMETRY_LAYER_EDIT_MAX_FEATURES,
  nameMaxLength: USER_GEOMETRY_NAME_MAX_LENGTH
} as const

// Layer-edit gate: the per-feature style editor is available only for small files.
export function canManageUserGeometryLayers(featureCount: number): boolean {
  return featureCount <= USER_GEOMETRY_LAYER_EDIT_MAX_FEATURES
}
